import { Check, Plus, Smartphone, Sparkles } from "lucide-react";
import { ACC_TYPES, accTypeOf, usesModels, formatPrice } from "@/lib/store";

export const forModelOf = (a, model) => (usesModels(accTypeOf(a)) ? model : "");

const Thumb = ({ a }) => (
  <div className="h-12 w-12 shrink-0 overflow-hidden rounded-xl bg-zinc-900">
    {a.images?.[0] ? <img src={a.images[0]} alt={a.model} loading="lazy" decoding="async" className="h-full w-full object-cover" /> : <Smartphone className="m-auto mt-3.5 h-5 w-5 text-zinc-500" />}
  </div>
);

const Toggle = ({ on, onClick, testid, labels }) => (
  <button type="button" data-testid={testid} onClick={onClick} aria-pressed={on}
    className={`flex shrink-0 items-center gap-1.5 rounded-full px-3.5 py-2 text-xs font-semibold transition-colors ${on ? "bg-emerald-400/15 text-emerald-300" : "bg-white text-black hover:bg-zinc-200"}`}>
    {on ? <Check className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}
    {on ? labels[1] : labels[0]}
  </button>
);

const ComboCard = ({ c, on, onClick, labels }) => (
  <li data-testid={`combo-${c.id}`} className="rounded-2xl border border-emerald-400/30 bg-emerald-400/[0.06] p-3">
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="flex items-center gap-1.5 text-sm font-semibold text-white"><Sparkles className="h-3.5 w-3.5 text-emerald-300" /> Combo {c.label} <span className="rounded-full bg-emerald-400 px-1.5 py-0.5 text-[10px] font-bold text-black">-10%</span></p>
        <p className="mt-1 truncate text-xs text-zinc-300">{c.items.map((a) => a.model).join(" + ")}</p>
        <p className="mt-1 text-sm"><span className="text-zinc-400 line-through">{formatPrice(c.full)}</span> <span data-testid={`combo-price-${c.id}`} className="font-bold text-white">{formatPrice(c.price)}</span></p>
      </div>
      <Toggle on={on} onClick={onClick} testid={`combo-add-${c.id}`} labels={labels} />
    </div>
  </li>
);

const ItemRow = ({ a, on, onClick, labels }) => {
  const type = ACC_TYPES.find((t) => t.id === accTypeOf(a));
  const sub = [type?.single, accTypeOf(a) === "fonte" ? a.wattage : null, a.color].filter(Boolean).join(" · ");
  return (
    <li data-testid={`upsell-item-${a.id}`} className="flex items-center gap-3 rounded-2xl border border-white/10 p-2.5 pr-3">
      <Thumb a={a} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-white">{a.model}</p>
        <p className="truncate text-xs text-zinc-400">{sub}</p>
        <p className="mt-0.5 text-sm font-bold text-white">{formatPrice(a.price)}</p>
      </div>
      <Toggle on={on} onClick={onClick} testid={`upsell-add-${a.id}`} labels={labels} />
    </li>
  );
};

export const AccessoryPicker = ({ list, combos, isOn, onToggle, onCombo, labels = ["Adicionar", "Adicionado"] }) => (
  <div data-lenis-prevent className="max-h-[48vh] space-y-4 overflow-y-auto px-6">
    {combos.length > 0 && (
      <ul className="space-y-2.5">
        {combos.map((c) => <ComboCard key={c.id} c={c} on={c.items.every(isOn)} onClick={() => onCombo(c)} labels={labels} />)}
      </ul>
    )}
    <ul className="space-y-2.5">
      {list.map((a) => <ItemRow key={a.id} a={a} on={isOn(a)} onClick={() => onToggle(a)} labels={labels} />)}
    </ul>
  </div>
);
